import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { KVKK_PROVIDERS } from "../../../utils/constants/constants";
import {
  KVKKProvider,
  OrganizationParameter,
} from "../../../utils/objects/organization-parameter";
import { ApiService } from "../../../utils/services/api.service";
import { filter, switchMap, toArray } from "rxjs/operators";
import { NotificationsService } from "angular2-notifications";
import { Observable } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
@Component({
  selector: "app-kvkk",
  templateUrl: "./kvkk.component.html",
  styleUrls: ["./kvkk.component.scss"],
})
export class KvkkComponent implements OnInit {
  public KVKKForm: FormGroup = new FormGroup({
    agencyForm: new FormGroup({
      provider: new FormControl(""),
      username: new FormControl(""),
      password: new FormControl(""),
      url: new FormControl(""),
      kvkk_url: new FormControl(""),
      express_consent_url: new FormControl(""),
      etk_url: new FormControl(""),
      client_id: new FormControl(""),
      client_secret: new FormControl(""),
    }),
    integration_active: new FormControl(false),
  });
  public KVKKIntegrators = KVKK_PROVIDERS;
  public KVKKProvider: Partial<KVKKProvider> = null;
  organizationID: number;
  isAgency: boolean = true;
  constructor(
    private apiService: ApiService,
    private notificationsService: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  async ngOnInit() {
    this.organizationID = this.activatedRoute.snapshot.parent.params.id;
    this.isAgency = this.activatedRoute.snapshot.data.isAgency;
    await this.getKVKKParameters();
    this.patchKVKKForm();
  }

  patchKVKKForm() {
    if (this.KVKKProvider) {
      if (this.isAgency) {
        this.KVKKForm.patchValue({
          agencyForm: {
            provider: this.getKVKKProviderValue('provider'),
            username: this.getKVKKProviderValue('username'),
            password: this.getKVKKProviderValue('password'),
            client_id: this.getKVKKProviderValue('client_id'),
            client_secret: this.getKVKKProviderValue('client_secret'),
            url: this.getKVKKProviderValue('url'),
            kvkk_url: this.getKVKKProviderValue('kvkk_url'),
            express_consent_url: this.getKVKKProviderValue('express_consent_url'),
            etk_url: this.getKVKKProviderValue('etk_url'),
          }
        });
      }
      this.KVKKForm.patchValue({
        integration_active:
        this.KVKKProvider.integration_active &&
        this.KVKKProvider.integration_active.value === "enable"
          ? true
          : false,
      })
    }
  }

  getKVKKProviderValue(key: string) {
    if (this.KVKKProvider[key]) {
      return this.KVKKProvider[key].value;
    }
    return "";
  }

  async getKVKKParameters() {
    // const urlParams = new URLSearchParams();
    // urlParams.set('parameter.type_Eq','Restriction');
    // urlParams.set('parameter.context_Eq','KVKK');
    const resp = (await this.apiService
      .getOrganizationParameters(this.organizationID)
      .pipe(
        switchMap((resp) => resp.data.rows),
        filter((row) => {
          return row["context"] === "KVKK";
        }),
        toArray()
      )
      .toPromise()
      .catch((e) =>
        this.notificationsService.error("Get KVKK Parameter", e.message || "")
      )) as OrganizationParameter[];
    if (resp && resp.length > 0) {
      this.KVKKProvider = {};
      for (let parameter of resp) {
        this.KVKKProvider[parameter.key] = parameter;
      }
    }
  }
  saveKVKKParameters() {
    let requests: Array<Observable<any>> = [];
    if (this.isAgency) {
      const agencyForm = this.KVKKForm.get("agencyForm") as FormGroup;
      for (let control in agencyForm.controls) {
        if (control === "integration_active") {
          continue;
        }
        if (this.KVKKProvider && this.KVKKProvider[control]) {
          requests.push(
            this.createPutRequest(
              "Restriction",
              "KVKK",
              this.KVKKProvider[control].id,
              control,
              agencyForm.get(control).value
            )
          );
        } else if (agencyForm.get(control).value) {
          requests.push(
            this.createPostRequest(
              "Restriction",
              "KVKK",
              control,
              agencyForm.get(control).value
            )
          );
        }
      }
    }
    const integrationActive = this.KVKKForm.get("integration_active").value;
    if (this.KVKKProvider && this.KVKKProvider.integration_active) {
      requests.push(
        this.createPutRequest(
          "Restriction",
          "KVKK",
          this.KVKKProvider.integration_active.id,
          "integration_active",
          integrationActive ? "enable" : "disable"
        )
      );
    } else {
      requests.push(
        this.createPostRequest(
          "Restriction",
          "KVKK",
          "integration_active",
          integrationActive ? "enable" : "disable"
        )
      );
    }
    if (requests && requests.length > 0) {
      Observable.forkJoin(requests).subscribe(
        (response) => {
          this.router.navigate(['./'], { relativeTo: this.activatedRoute });
          this.ngOnInit();
          this.notificationsService.success("Success", "Save Success");
        },
        (error) => {
          this.router.navigate(['./'], { relativeTo: this.activatedRoute });
          this.notificationsService.error("Error", "Error occured");
        }
      );
    }
  }

  createPostRequest(type, context, key, value): Observable<any> {
    return this.apiService.addOrganizationParameter(this.organizationID, {
      type: type,
      context: context,
      key: key,
      value: value,
    });
  }

  createPutRequest(
    type,
    context,
    parameterID: number,
    key,
    value
  ): Observable<any> {
    return this.apiService.updateOrganizationParameter(
      this.organizationID,
      parameterID,
      {
        type: type,
        context: context,
        key: key,
        value: value,
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/frames/kvkk/kvkk.component.ts